import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'page-not-found-page',
  templateUrl: './page-not-found-page.component.html',
  styleUrls: ['./page-not-found-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  gotoHome() {
    this.router.navigate(['/home']);
  }
}
